/**
 * Decides whether an authenticated user should be stopped at the
 * "your account isn't set up yet" screen.
 *
 * Kept as a pure function so the outage-safety rule below is directly testable: an empty
 * permission set must only be treated as real once the server has actually answered.
 */
export interface AccessGateInput {
  /** True only once application-configuration was fetched successfully. */
  permissionsResolved: boolean;
  /** Granted permissions from application-configuration. */
  permissions: string[];
}

export const shouldBlockAsUnconfigured = ({
  permissionsResolved,
  permissions,
}: AccessGateInput): boolean => {
  // Before the server has answered we know nothing. Blocking here would turn any
  // transient failure of /api/abp/application-configuration into a lockout for
  // every user, so the unknown case must always fall through.
  if (!permissionsResolved) {
    return false;
  }

  return permissions.length === 0;
};
